/**
 * 관리자 2단계 로그인 (/adm/login2) — 구글 OTP 자리(입력칸만 있고 아직 검증하지 않는다)
 * ($j.Pages.Admin.AdminLogin2 / body data-page-name="AdminLogin2")
 *
 * 예전 폼의 onSubmit="return formCheck();" 은 없는 함수를 불러 오류만 내고 그대로 전송됐다 — 그 오류만 뺐다.
 */
export default class AdminLogin2 {
    initialize() {
        $('a[data-al-noop]').on('click', (e) => e.preventDefault());
    }
}
